'use strict';

function isUndefined(o) {
  return o === undefined;
}

module.exports = isUndefined;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/isUndefined.js
// module id = 68
// module chunks = 0